import { useState } from "react";
import { Search, MessageCircle, Phone, Mail, FileText, Shield, Package, Smartphone, ArrowLeft } from "lucide-react";
import "../styles/SupportPage.css";
import { Link } from "react-router-dom";

export default function SupportPage() {
  const [searchQuery, setSearchQuery] = useState("");

  const categories = [
    {
      title: "Commander",
      icon: <Package size={24} />,
      articles: [
        "Comment commander mes stickers ?",
        "Quels modes de paiement acceptez-vous ?",
        "Délais de livraison",
        "Suivre ma commande"
      ]
    },
    {
      title: "Utilisation",
      icon: <Smartphone size={24} />,
      articles: [
        "Comment scanner un QR code ?",
        "Associer un objet à mon compte",
        "Modifier mes informations",
        "Ajouter un contact de confiance"
      ]
    },
    {
      title: "Sécurité",
      icon: <Shield size={24} />,
      articles: [
        "Comment sont protégées mes données ?",
        "Que faire si je perds mon objet ?",
        "Signaler un QR code abusif",
        "Politique de confidentialité"
      ]
    },
    {
      title: "Compte",
      icon: <FileText size={24} />,
      articles: [
        "Créer mon compte",
        "Réinitialiser mon mot de passe",
        "Gérer mes abonnements",
        "Supprimer mon compte"
      ]
    }
  ];

  const contactMethods = [
    {
      title: "Chat en direct",
      icon: <MessageCircle size={24} />,
      description: "Discutez avec notre équipe",
      action: "Ouvrir le chat",
      available: false
    },
    {
      title: "Appel téléphonique",
      icon: <Phone size={24} />,
      description: "+225 07 12 20 49 86",
      action: "Appeler maintenant",
      available: true
    },
    {
      title: "Email",
      icon: <Mail size={24} />,
      description: "support@ultimatag.com",
      action: "Envoyer un email",
      available: true
    }
  ];

  return (
    <div className="support-page">
      <section className="support-hero">
        <div className="container">
        <Link to="/" className="privacy-back-button">
          <ArrowLeft size={20} />
          Retour à l'accueil
        </Link>
          <h1>Centre d'aide</h1>
          <p>Trouvez rapidement des réponses à vos questions</p>
          
          {/* <div className="search-container">
            <Search size={20} />
            <input
              type="text"
              placeholder="Rechercher une question..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div> */}
        </div>
      </section>

      <div className="support-container">
        {/* <section className="categories-section">
          <h2>Catégories</h2>
          <div className="categories-grid">
            {categories.map((category, index) => (
              <div key={index} className="category-card">
                <div className="category-icon">{category.icon}</div>
                <h3>{category.title}</h3>
                <ul className="articles-list">
                  {category.articles.map((article, idx) => (
                    <li key={idx}>
                      <a href="#">{article}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section> */}

        <section className="contact-section">
          <h2>Contactez-nous</h2>
          <p>Notre équipe est disponible pour vous aider</p>
          
          <div className="contact-methods-grid">
            {contactMethods.map((method, index) => (
              <div key={index} className="contact-method-card">
                <div className="method-icon">{method.icon}</div>
                <h3>{method.title}</h3>
                <p>{method.description}</p>
                <button className={`method-button ${method.available ? 'available' : 'unavailable'}`}>
                  {method.action}
                </button>
                {method.available ? (
                  <div className="availability-badge">Disponible</div>
                ):(<div className="availability-badge2">Bientôt</div>)}
              </div>
            ))}
          </div>
        </section>

        {/* <section className="quick-links">
          <h2>Liens rapides</h2>
          <div className="links-grid">
            <a href="/legal" className="quick-link">Mentions légales</a>
            <a href="/privacy" className="quick-link">Politique de confidentialité</a>
            <a href="/terms" className="quick-link">Conditions d'utilisation</a>
            <a href="/faq" className="quick-link">FAQ complète</a>
          </div>
        </section> */}
      </div>
    </div>
  );
}